import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import { PiMoonStarsThin } from "react-icons/pi";
import { PiSunHorizonThin } from "react-icons/pi";
import { PiSunThin } from "react-icons/pi";
import { PiSunFill } from "react-icons/pi";
import { PiSunDimFill } from "react-icons/pi";
import { PiMountainsThin } from "react-icons/pi";
import { PiMountainsDuotone } from "react-icons/pi";
import { PiMountainsFill } from "react-icons/pi";
import { DiCompass } from "react-icons/di";

import React, { useEffect, useState } from "react";
import "./card.css";
import FilterHdrIcon from "@mui/icons-material/FilterHdr";
import Spinner from "../Spinner";
import { axiosBaseInstance, SERVER_URL, topo_colors } from "../../data";

const Card = ({
    getContour1,
    getContour2,
    clearContour,
    getMap1,
    getMap2,
    changeMap,
    currentMapTypeIndex,
    currentMapType,
    detectChange,
    loading,
    volumeSegments,
    getSegmentVolume,
    removeOverlayTiles,
    contourPaths,
    topoPaths,
    setSegmentVolume,
    setWithinSegVolume,
    selectOrthoRef,
    changeTopo,
    removeTopo,
    openModal,
    setLayerIndicator,
    currMapData,
    contours,
    setLoading,
    listGeneratedContours,
}) => {
    return (
        <div
            style={{
                // zIndex: 1000,
                position: "absolute",
                left: "50%",
                translate: "-50%",
                width: "90%",
            }}
            id="caard"
            className={`hideScrollbar`} // include close
        >
            <div
                href="#"
                style={{
                    // backgroundColor: "rgb(79 113 197)",
                    // backgroundColor: "#212529",
                    width: "100%",
                    height: "100%",
                    // display: isCollapsed ? 'none' : 'block'
                }}
                // className="block max-w-sm pl-6 pr-6 pt-2 bg-white border-gray-200 rounded shadow hover:bg-gray-100 overflow-scroll scrolling"
            >
                <div href="#" className="block text-start pt-3">
                    <h5 className="text-white">Layers</h5>
                </div>
                <div>
                    <AccordionUsage
                        getContour1={getContour1}
                        getContour2={getContour2}
                        clearContour={clearContour}
                        getMap1={getMap1}
                        getMap2={getMap2}
                        changeMap={changeMap}
                        currentMapTypeIndex={currentMapTypeIndex}
                        currentMapType={currentMapType}
                        detectChange={detectChange}
                        volumeSegments={volumeSegments}
                        getSegmentVolume={getSegmentVolume}
                        removeOverlayTiles={removeOverlayTiles}
                        contourPaths={contourPaths}
                        topoPaths={topoPaths}
                        setSegmentVolume={setSegmentVolume}
                        setWithinSegVolume={setWithinSegVolume}
                        selectOrthoRef={selectOrthoRef}
                        changeTopo={changeTopo}
                        removeTopo={removeTopo}
                        openModal={openModal}
                        setLayerIndicator={setLayerIndicator}
                        currMapData={currMapData}
                        contours={contours}
                        setLoading={setLoading}
                        listGeneratedContours={listGeneratedContours}
                    />
                </div>
                <div
                    style={{
                        position: "absolute",
                        top: "1%",
                        right: "2%",
                    }}
                >
                    {loading && <Spinner width="30px" />}
                </div>
            </div>
        </div>
    );
};

function AccordionUsage({
    getContour1,
    getContour2,
    clearContour,
    changeMap,
    currentMapTypeIndex,
    detectChange,
    volumeSegments,
    getSegmentVolume,
    removeOverlayTiles,
    contourPaths,
    topoPaths,
    setSegmentVolume,
    setWithinSegVolume,
    selectOrthoRef,
    changeTopo,
    removeTopo,
    openModal,
    setLayerIndicator,
    currMapData,
    contours,
    setLoading,
    listGeneratedContours,
}) {
    const [checkedRadio, setCheckedRadio] = useState(0);
    const [checkedRadioMap, setCheckedRadioMap] = useState(0);
    const [checkedRadioSegment, setCheckedRadioSegment] = useState(0);
    const [checkedRadioSlope, setCheckedRadioSlope] = useState(0);
    const [checkRadioTopo, setCheckedRadioTopo] = useState([]);
    const [contInterval, setContInterval] = useState(5);
    const [checkedHS, setCheckedHS] = useState(0);
    const [hillshadeInputs, setHillshadeInputs] = useState({
        sunEl: 60,
        sunAz: 120,
        vert: 2,
    });

    const generateContour = async () => {
        setLoading(true);
        axiosBaseInstance
            .post(
                `${SERVER_URL}/cont`,
                {
                    interval: contInterval,
                    name: currMapData.name,
                    tifVisit: currMapData.tifPaths[currentMapTypeIndex],
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                listGeneratedContours();
                setLoading(false);
            })
            .catch((err) => {
                console.log(err.message);
                setLoading(false);
            });
    };
    const handleNumRangeCounter = (step, min, max, sign, fn) => {
        if (sign === "i") {
            fn((prev) => {
                return Math.min(parseFloat(prev + step), max);
            });
        } else if (sign === "d") {
            fn((prev) => {
                return Math.max(parseFloat(prev - step), min);
            });
        }
    };

    const changeElevationShade = (_e) => {
        setHillshadeInputs((prev) => ({ ...prev, [_e[0]]: parseInt(_e[1]) }));
        changeMap(0, checkedHS === 1 ? "hillshade" : "hillshade2", 0, _e);
    };
    const changeShadeOnBtnClick = (name, multiplyer) => {
        if (name === "vert") {
            setHillshadeInputs((prev) => {
                prev = {
                    ...prev,
                    [name]:
                        multiplyer > 0
                            ? Math.min(prev[name] + multiplyer, 5)
                            : Math.max(prev[name] + multiplyer, 1),
                };
                changeMap(0, checkedHS === 1 ? "hillshade" : "hillshade2", 0, [
                    name,
                    prev[name],
                ]);
                return prev;
            });
        } else if (name === "sunAz") {
            setHillshadeInputs((prev) => {
                prev = {
                    ...prev,
                    [name]:
                        multiplyer > 0
                            ? Math.min(prev[name] + multiplyer * 30, 360)
                            : Math.max(prev[name] + multiplyer * 30, 0),
                };
                changeMap(0, checkedHS === 1 ? "hillshade" : "hillshade2", 0, [
                    name,
                    prev[name],
                ]);
                return prev;
            });
        } else if (name === "sunEl") {
            setHillshadeInputs((prev) => {
                prev = {
                    ...prev,
                    [name]:
                        multiplyer > 0
                            ? Math.min(prev[name] + multiplyer * 10, 90)
                            : Math.max(prev[name] + multiplyer * 10, 0),
                };
                changeMap(0, checkedHS === 1 ? "hillshade" : "hillshade2", 0, [
                    name,
                    prev[name],
                ]);
                return prev;
            });
        }
    };

    const getElevationIcon = (val) => {
        if (val > 0 && val < 45) {
            return <PiSunHorizonThin />;
        } else if (val >= 45 && val < 90) {
            return <PiSunThin />;
        } else if (val >= 90) {
            return <PiSunFill />;
        } else {
            return <PiMoonStarsThin />;
        }
    };
    const getVexIcon = (val) => {
        if (val > 0 && val < 3) {
            return <PiMountainsThin />;
        } else if (val >= 3 && val < 5) {
            return <PiMountainsDuotone />;
        } else {
            return <PiMountainsFill />;
        }
    };

    useEffect(() => {
        if (checkedRadioSegment === 0) {
            setSegmentVolume(null);
            setWithinSegVolume(null);
        }
    }, [detectChange, checkedRadioSegment]);

    return (
        <div>
            <hr className="mb-0" />

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <img
                        src="/assets/icons/landscape.png"
                        alt="elevation"
                        width="24px"
                    />{" "}
                    &nbsp; Elevation Models
                </AccordionSummary>
                <AccordionDetails>
                    <div className="btn-group btn-group-sm" role="group">
                        <button
                            className={`btn ${
                                checkedRadioMap === 0
                                    ? "active text-dark"
                                    : "cyan-theme"
                            }`}
                            ref={selectOrthoRef}
                            style={{ fontSize: "10px" }}
                            onClick={(e) => {
                                // getMap2()
                                setCheckedHS(0);
                                setLayerIndicator("elevation");
                                changeMap(currentMapTypeIndex, "orthoPaths");
                                setCheckedRadioMap(0);
                                setCheckedRadioSegment(0);
                                setCheckedRadio(0);

                                // setCheckedRadio(0)
                            }}
                        >
                            Orthomosiac
                        </button>
                        <button
                            className={`btn ${
                                checkedRadioMap === 1
                                    ? "active text-dark"
                                    : "cyan-theme"
                            }`}
                            style={{ fontSize: "10px" }}
                            onClick={(e) => {
                                setCheckedHS(0);
                                setLayerIndicator("elevation");
                                changeMap(currentMapTypeIndex, "DSMPaths");
                                setCheckedRadioMap(1);
                                setCheckedRadioSegment(0);
                                setCheckedRadio(0);
                                // setCheckedRadio(0)
                            }}
                        >
                            DSM
                        </button>
                        <button
                            className={`btn ${
                                checkedRadioMap === 2
                                    ? "active text-dark"
                                    : "cyan-theme"
                            }`}
                            style={{ fontSize: "10px" }}
                            onClick={(e) => {
                                setCheckedHS(0);
                                setLayerIndicator("elevation");
                                changeMap(currentMapTypeIndex, "DTMPaths");
                                setCheckedRadioMap(2);
                                setCheckedRadioSegment(0);
                                setCheckedRadio(0);
                                // setCheckedRadio(0)
                            }}
                        >
                            DTM
                        </button>
                        <button
                            className={`btn ${
                                checkedRadioMap === 3
                                    ? "active text-dark"
                                    : "cyan-theme"
                            }`}
                            style={{ fontSize: "10px" }}
                            onClick={(e) => {
                                removeOverlayTiles();
                                setCheckedHS(1);
                                changeMap(0, "hillshade");
                                setLayerIndicator("hillshade");
                                setCheckedRadio(0);
                                setCheckedRadioMap(3);
                                setCheckedRadioSegment(0);
                            }}
                        >
                            Hillshade
                        </button>
                    </div>

                    {checkedHS !== 0 && (
                        <>
                            <div className="d-flex justify-content-center mt-3">
                                Dynamic Hillshade
                            </div>
                            <div className="d-flex my-2">
                                <input
                                    type="checkbox"
                                    id="colorckeck"
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            // getMap2()
                                            removeOverlayTiles();
                                            setCheckedHS(2);
                                            changeMap(0, "hillshade2");
                                            setLayerIndicator("hillshade");
                                            setCheckedRadio(0);
                                            setCheckedRadioMap(3);
                                            setCheckedRadioSegment(0);
                                        } else {
                                            removeOverlayTiles();
                                            setCheckedHS(1);
                                            changeMap(0, "hillshade");
                                            setLayerIndicator("hillshade");
                                            setCheckedRadio(0);
                                            setCheckedRadioMap(3);
                                            setCheckedRadioSegment(0);
                                        }
                                    }}
                                />{" "}
                                &nbsp; <label htmlFor="colorcheck">Color</label>
                            </div>
                            <div className="d-flex mb-2 flex-column">
                                <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                        Exaggeration{" "}
                                        {getVexIcon(hillshadeInputs.vert)}
                                    </div>
                                    <div>{hillshadeInputs.vert}</div>
                                </div>
                                <div
                                    className="d-flex justify-content-between align-items-center gap-1"
                                    style={{ width: "100%" }}
                                >
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%", opacity: hillshadeInputs.vert <= 1 ? 0.4:1 }}
                                        onClick={() =>
                                            changeShadeOnBtnClick("vert", -1)
                                        }
                                        disabled={hillshadeInputs.vert <= 1}
                                    >
                                        {"<"}
                                    </button>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="vert"
                                        min="1"
                                        max="5"
                                        step="1"
                                        value={hillshadeInputs["vert"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                            width: "80%",
                                        }}
                                    />
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%", opacity: hillshadeInputs.vert >= 5 ? 0.4:1 }}
                                        onClick={() =>
                                            changeShadeOnBtnClick("vert", 1)
                                        }
                                        disabled={hillshadeInputs.vert >= 5}
                                    >
                                        {">"}
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex mb-2 flex-column">
                                <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                        Sun Azimuth{" "}
                                        {
                                            <DiCompass
                                                style={{
                                                    transform: `rotate(${hillshadeInputs.sunAz+45}deg)`,
                                                }}
                                            />
                                        }
                                    </div>
                                    <div>{hillshadeInputs.sunAz}&deg;</div>
                                </div>
                                <div
                                    className="d-flex justify-content-between align-items-center gap-1"
                                    style={{ width: "100%" }}
                                >
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%", opacity: hillshadeInputs.sunAz <= 0 ? 0.4:1 }}
                                        onClick={() =>
                                            changeShadeOnBtnClick("sunAz", -1)
                                        }
                                        disabled={hillshadeInputs.sunAz <= 0}
                                    >
                                        {"<"}
                                    </button>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="sunAz"
                                        min="0"
                                        max="360"
                                        step="30"
                                        value={hillshadeInputs["sunAz"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                            width: "80%",
                                        }}
                                    />
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%", opacity: hillshadeInputs.sunAz >= 360 ? 0.4:1 }}
                                        onClick={() =>
                                            changeShadeOnBtnClick("sunAz", 1)
                                        }
                                        disabled={hillshadeInputs.sunAz >= 360}
                                    >
                                        {">"}
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex mb-2 flex-column">
                                <div className="d-flex justify-content-between">
                                    <div className="text-start">
                                        Sun Elevation{" "}
                                        {getElevationIcon(
                                            hillshadeInputs.sunEl
                                        )}
                                    </div>
                                    <div>{hillshadeInputs.sunEl}&deg;</div>
                                </div>
                                <div
                                    className="d-flex justify-content-between align-items-center gap-1"
                                    style={{ width: "100%" }}
                                >
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%", opacity: hillshadeInputs.sunEl <= 0 ? 0.4:1 }}
                                        onClick={() =>
                                            changeShadeOnBtnClick("sunEl", -1)
                                        }
                                        disabled={hillshadeInputs.sunEl <= 0}
                                    >
                                        {"<"}
                                    </button>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="sunEl"
                                        min="0"
                                        max="90"
                                        step="10"
                                        value={hillshadeInputs["sunEl"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                            width: "80%",
                                        }}
                                    />
                                    <button
                                        className="cyan-theme rounded"
                                        style={{ height: "25px", width: "10%",opacity: hillshadeInputs.sunEl >= 90 ? 0.4:1 }}
                                        disabled={hillshadeInputs.sunEl >= 90}
                                        onClick={() =>
                                            changeShadeOnBtnClick("sunEl", 1)
                                        }
                                    >
                                        {">"}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </AccordionDetails>
            </Accordion>

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <img
                        src="/assets/icons/contour.png"
                        alt="elevation"
                        width="24px"
                    />{" "}
                    &nbsp; Contours
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        className="d-flex gap-3"
                        style={{ flexDirection: "column" }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                            }}
                        >
                            <button
                                className="btn btn-dark"
                                onClick={() =>
                                    handleNumRangeCounter(
                                        5,
                                        5,
                                        50,
                                        "d",
                                        setContInterval
                                    )
                                }
                            >
                                {" "}
                                <FaMinus />{" "}
                            </button>
                            <div>{contInterval}m Interval </div>
                            <button
                                className="btn btn-dark"
                                onClick={() =>
                                    handleNumRangeCounter(
                                        5,
                                        5,
                                        50,
                                        "i",
                                        setContInterval
                                    )
                                }
                            >
                                <FaPlus />{" "}
                            </button>
                        </div>
                        {/* <input type="number" min="5" max="25" placeholder="Inverval" onChange={(e) => setContInterval(prev => {
                            if (parseInt(e.target.value) > 25) return 25;
                            parseFloat(e.target.value)
                        })} /> */}
                        <button
                            className="btn btn-dark"
                            onClick={generateContour}
                        >
                            Create Contour
                        </button>
                        <div
                            style={{ maxHeight: "300px", overflowY: "auto" }}
                            className="hideScrollbar"
                        >
                            <div className="d-flex gap-2">
                                <input
                                    type="radio"
                                    id="nonecont"
                                    readOnly
                                    checked={checkedRadio === 0}
                                    name="toggle-contour"
                                    style={{
                                        accentColor: "var(--secondary-2)",
                                    }}
                                    onClick={(e) => {
                                        setLayerIndicator("contour");
                                        clearContour();
                                        setCheckedRadio(0);
                                    }}
                                />
                                <label htmlFor="nonecont"> None</label>
                            </div>
                            {contours?.map((name, idx) => {
                                const pth = `contours/${currMapData.tifPaths[currentMapTypeIndex]}/${name}`;
                                return (
                                    <div
                                        className="d-flex gap-3 mt-2"
                                        key={`card_${pth}`}
                                    >
                                        <input
                                            type="radio"
                                            id={"contour" + idx}
                                            name={"toggle-contour"}
                                            readOnly
                                            style={{
                                                accentColor:
                                                    "var(--secondary-2)",
                                            }}
                                            checked={checkedRadio === idx + 1}
                                            onClick={(e) => {
                                                setLayerIndicator("contour");
                                                getContour1(pth, "red");
                                                setCheckedRadio(idx + 1);
                                                // changeTopo()
                                            }}
                                        />
                                        <label htmlFor={"contour" + idx}>
                                            {name.split(".")[0]}mm
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <img
                        src="/assets/icons/sound (1).png"
                        alt="volume segment"
                        width="24px"
                    />{" "}
                    &nbsp; Volume Segments
                </AccordionSummary>
                <AccordionSummary>
                    <div
                        className="d-flex gap-3"
                        style={{ flexDirection: "column" }}
                    >
                        <button
                            className="btn btn-sm btn-dark"
                            onClick={() => openModal(true)}
                        >
                            <FileUploadIcon />
                        </button>

                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="none-stock"
                                readOnly
                                style={{ accentColor: "var(--secondary-2)" }}
                                checked={checkedRadioSegment === 0}
                                name="toggle-stock"
                                onClick={(e) => {
                                    // setCheckedRadio(0)
                                    // clearContour();
                                    setLayerIndicator("volume");
                                    setCheckedRadioSegment(0);
                                    setCheckedRadioMap(-1);
                                    setCheckedRadioSlope(0);
                                    // removeOverlayTiles();
                                }}
                            />
                            <label htmlFor="none-stock"> None</label>
                        </div>
                        {volumeSegments?.stocks?.map((stockpath, idx) => (
                            <div
                                className="d-flex gap-2"
                                key={`stock_${stockpath}`}
                            >
                                <input
                                    type="radio"
                                    id={stockpath + idx}
                                    readOnly
                                    checked={checkedRadioSegment === idx + 1}
                                    name="toggle-stock"
                                    style={{
                                        accentColor: "var(--secondary-2)",
                                    }}
                                    onClick={(e) => {
                                        // setCheckedRadio(0)
                                        // clearContour();
                                        setLayerIndicator("volume");
                                        setCheckedRadioSegment(idx + 1);
                                        setCheckedRadioMap(-1);
                                        setCheckedRadio(0);
                                        setCheckedRadioSlope(0);

                                        changeMap(
                                            currentMapTypeIndex,
                                            "volumeSegments",
                                            idx
                                        );
                                        getSegmentVolume(idx);
                                    }}
                                />
                                <label htmlFor={stockpath + idx}>
                                    {" "}
                                    {stockpath.split("/")[3]}
                                </label>
                            </div>
                        ))}
                    </div>
                </AccordionSummary>
            </Accordion>

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <img
                        src="/assets/icons/layers.png"
                        alt="topo"
                        width="24px"
                    />{" "}
                    &nbsp; TOPO
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        className="d-flex gap-3 hideScrollbar"
                        style={{
                            flexDirection: "column",
                            maxHeight: "300px",
                            overflowY: "auto",
                        }}
                    >
                        {topoPaths &&
                            topoPaths.paths.length !== 0 &&
                            topoPaths.paths.map((pth, idx) => (
                                <div
                                    className="d-flex gap-2 justify-content-between align-items-center"
                                    key={`topo_${pth}`}
                                >
                                    <label
                                        htmlFor={"topo" + idx}
                                        style={{
                                            display: "flex",
                                            width: 200,
                                            alignItems: "center",
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor:
                                                    topo_colors[
                                                        idx % topo_colors.length
                                                    ],
                                                width: 25,
                                                height: 12,
                                                border: "0.5px solid var(--color-border)",
                                                borderRadius: "5px",
                                                color: "var(--color-font)",
                                            }}
                                        ></div>
                                        &nbsp;
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            {
                                                pth.split("/")[
                                                    pth.split("/").length - 1
                                                ]
                                            }
                                        </div>
                                    </label>
                                    <input
                                        type="checkbox"
                                        id={"topo" + idx}
                                        name={"toggle-topo"}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                        }}
                                        readOnly
                                        // checked={checkedRadio === idx + 1}
                                        // checked={checkRadioTopo[idx]}
                                        onClick={(e) => {
                                            // setLayerIndicator('topo')
                                            if (!e.target.checked) {
                                                // removeTopo(pth)
                                                removeTopo(
                                                    `${currMapData.root}/${pth}.geojson`
                                                );
                                            } else {
                                                // changeTopo(pth)
                                                changeTopo(
                                                    `${currMapData.root}/${pth}.geojson`,
                                                    topo_colors[
                                                        idx % topo_colors.length
                                                    ]
                                                );
                                            }
                                            // removeTopo()
                                        }}
                                    />{" "}
                                    &nbsp;
                                </div>
                            ))}
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel2-content"
                    id="panel2-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <img
                        src="/assets/icons/map.png"
                        alt="slope map"
                        width="24px"
                    />{" "}
                    &nbsp; Slope Maps
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        className="d-flex gap-3"
                        style={{ flexDirection: "column" }}
                    >
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="noneslope"
                                name="toggle-slope"
                                style={{ accentColor: "var(--secondary-2)" }}
                                readOnly
                                checked={checkedRadioSlope === 0}
                                onClick={(e) => {
                                    // getMap2()
                                    removeOverlayTiles();
                                    setLayerIndicator("elevation");
                                    setCheckedRadioMap(-1);
                                    setCheckedRadioSegment(0);
                                    setCheckedRadioSlope(0);
                                    // setCheckedRadio(0)
                                }}
                            />
                            <label htmlFor="noneslope"> None</label>
                        </div>

                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="slope_1"
                                readOnly
                                style={{ accentColor: "var(--secondary-2)" }}
                                checked={checkedRadioSlope === 1}
                                name="toggle-slope1"
                                onClick={(e) => {
                                    setLayerIndicator("slope");
                                    changeMap(
                                        currentMapTypeIndex,
                                        "slopePaths"
                                    );
                                    setCheckedRadioMap(-1);
                                    setCheckedRadioSegment(0);
                                    setCheckedRadio(0);
                                    setCheckedRadioSlope(1);
                                }}
                            />
                            <label htmlFor="slope_1"> Slope Map 1</label>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel2-content"
                    id="panel2-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <FilterHdrIcon sx={{ color: "var(--secondary-2)" }} />{" "}
                    &nbsp; Haul Road Analysis
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        className="d-flex gap-3"
                        style={{ flexDirection: "column" }}
                    >
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="nonehaul"
                                name="toggle-haul"
                                style={{ accentColor: "var(--secondary-2)" }}
                                readOnly
                                // checked={checkedRadioMap === -1}
                                onClick={(e) => {
                                    // getMap2()
                                    removeOverlayTiles();
                                    setLayerIndicator("haulroad");
                                    setCheckedRadioSegment(0);
                                    setCheckedRadioSlope(0);
                                    // setCheckedRadio(0)
                                }}
                            />
                            <label htmlFor="nonehaul"> None</label>
                        </div>
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="hr"
                                name="toggle-haul"
                                readOnly
                                style={{ accentColor: "var(--secondary-2)" }}
                                // checked={checkedRadioMap === 0}
                                onClick={(e) => {
                                    // getMap2()
                                    setLayerIndicator("haulroad");
                                    changeMap(currentMapTypeIndex, "haulPaths");
                                    setCheckedRadioSegment(0);
                                    setCheckedRadio(0);

                                    // setCheckedRadio(0)
                                }}
                            />
                            <label htmlFor="hr"> Haul Road</label>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            {/* <Accordion
                style={{
                    background: "var(--primary-2)",
                    borderRadius: "5px",
                    color: "var(--color-font)",
                    boxShadow: "none",
                    marginBottom: "10px",
                }}
            >
                <AccordionSummary
                    expandIcon={
                        <ExpandMoreIcon sx={{ color: "var(--secondary-3)" }} />
                    }
                    aria-controls="panel2-content"
                    id="panel2-header"
                    // style={{ marginLeft: "8%" }}
                >
                    <FilterHdrIcon sx={{ color: "var(--secondary-2)" }} />{" "}
                    &nbsp; Hillshade Analysis
                </AccordionSummary>
                <AccordionDetails style={{ marginLeft: "8%" }}>
                    <div
                        className="d-flex gap-3"
                        style={{ flexDirection: "column" }}
                    >
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="nonehill"
                                name="toggle-hill"
                                style={{ accentColor: "var(--secondary-2)" }}
                                checked={checkedHS === 0}
                                onClick={(e) => {
                                    setCheckedHS(0);
                                    removeOverlayTiles();
                                    removeOverlayTiles();
                                }}
                            />
                            <label htmlFor="nonehill"> None</label>
                        </div>
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="hs"
                                name="hillshade1"
                                style={{ accentColor: "var(--secondary-2)" }}
                                checked={checkedHS === 1}
                                onClick={(e) => {
                                    // getMap2()
                                    removeOverlayTiles();
                                    setCheckedHS(1);
                                    changeMap(0, "hillshade");
                                    setLayerIndicator("hillshade");
                                    setCheckedRadio(0);
                                    setCheckedRadioMap(-1);
                                    setCheckedRadioSegment(0);
                                }}
                            />
                            <label htmlFor="hs"> Hillshade</label>
                        </div>
                        <div className="d-flex gap-2">
                            <input
                                type="radio"
                                id="hsc"
                                name="hillshade2"
                                style={{ accentColor: "var(--secondary-2)" }}
                                checked={checkedHS === 2}
                                onClick={(e) => {
                                    // getMap2()
                                    removeOverlayTiles();
                                    setCheckedHS(2);
                                    changeMap(0, "hillshade2");
                                    setLayerIndicator("hillshade");
                                    setCheckedRadio(0);
                                    setCheckedRadioMap(-1);
                                    setCheckedRadioSegment(0);
                                }}
                            />
                            <label htmlFor="hsc">Colored Hillshade</label>
                        </div>
                        {checkedHS !== 0 && (
                            <>
                                <div className="d-flex gap-2 flex-column">
                                    <div className="d-flex justify-content-between">
                                        <div className="text-start">
                                            Exaggeration
                                        </div>
                                        <div>{hillshadeInputs.vert}</div>
                                    </div>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="vert"
                                        min="1"
                                        max="5"
                                        step="1"
                                        value={hillshadeInputs["vert"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                        }}
                                    />
                                </div>
                                <div className="d-flex gap-2 flex-column">
                                    <div className="d-flex justify-content-between">
                                        <div className="text-start">
                                            Sun Azimuth
                                        </div>
                                        <div>{hillshadeInputs.sunAz}&deg;</div>
                                    </div>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="sunAz"
                                        min="0"
                                        max="360"
                                        step="30"
                                        value={hillshadeInputs["sunAz"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                        }}
                                    />
                                </div>
                                <div className="d-flex gap-2 flex-column">
                                    <div className="d-flex justify-content-between">
                                        <div className="text-start">
                                            Sun Elevation
                                        </div>
                                        <div>{hillshadeInputs.sunEl}&deg;</div>
                                    </div>
                                    <input
                                        onChange={(e) =>
                                            changeElevationShade([
                                                e.target.name,
                                                e.target.value,
                                            ])
                                        }
                                        type="range"
                                        name="sunEl"
                                        min="0"
                                        max="90"
                                        step="10"
                                        value={hillshadeInputs["sunEl"]}
                                        style={{
                                            accentColor: "var(--secondary-2)",
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </AccordionDetails>
            </Accordion> */}
        </div>
    );
}
export default Card;
